// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__8N-p2","left":"StickyBox_left__1IDsk","right":"StickyBox_right__1fhP6"};